import Vue from 'vue';
import Vuex from 'vuex';
import { vuexfireMutations } from 'vuexfire';
import user from './user';
import assets from './assets';
import dropbox from './dropbox';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    site: {
      title: 'Metador',
    },
  },
  getters: {
    site(state) {
      return state.site;
    },
  },
  mutations: {
    ...vuexfireMutations,
  },
  modules: {
    user,
    assets,
    dropbox,
  },
});
